import React, { useContext } from "react";
import { strings } from "../../strings";
import styles from "./ArtistSeries.module.scss";
import dons from "../../assets/dons.png";
import mara from "../../assets/mara.png";
import evereth from "../../assets/evereth.png";
import ArtistAvatar from "../../components/ArtistAvatar/ArtistAvatar";
import Artwork from "../../components/Artwork/Artwork";
import DONS from "../../assets/DONS_KIC.png";
import MARA from "../../assets/MARA_KIC.png";
import EVERETH from "../../assets/EV3RETH_KIC.jpg";
import bag from "../../assets/bag.png";
import bagAnim from "../../assets/bag-anim.gif";

import { AppContext } from "../../context/AppContext";
import faker from "@faker-js/faker";

export default function ArtistSeries() {
  const artists = [
    {
      name: "1 of 1 BAG",
      img: bag,
      price: "RESALE ONLY",
      description: `Recently, Wayne Snow commissioned work from Kofta, a leading Design Studio in Kyiv, Ukraine to produce a limited run of designer backpacks made using a unique leather moulding technique. Due to the war, Kofta can no longer operate.
      Luckily one sample piece was produced before the war started and no more physical editions will be produced again! This backpack symbolises the plight of so many Ukrainians that had to pick up and leave their lives behind, with nothing but a backpack to salvage what they could.
      <br/><br/>This 1 of 1 NFT will give its owner the rights to claim the 1-of-1 physical backpack (retails for €1,500). All proceeds from the auction goes to children impacted by the Ukraine conflict .`,
      revealed: true,
      artwork: bagAnim,
      tags: [
        "Created by Ukrainian fashion house KOFTA. Using futuristic techniques (3D-modeling, printing and cutting) mixed with the traditional leather craft (molding, drying, straining and hand painting).",
      ],
      link: "https://paras.id/token/x.paras.near::413517/413517:1",
    },
    {
      name: "THE DONS",
      img: dons,
      price: "RESALE ONLY",

      revealed: true,
      artwork: DONS,
      description: `This piece is untitled and represents hope in the face of adversity through the hopeful Don carrying Kofta’s bag. 

        The young Don is looking up at his uncertain destination full of ambition and his bag is full of his belongings. 
        
        The bag is comically oversized and you’re meant to get a sense that the journey before him is huge - but he is ready for it.`,
      tags: [
        "The Dons is a collection of 3,500 Mafia Bosses coming to take over NEAR Protocol. The lead Artist from The Dons produced the artwork specifically for this project.",
      ],
      link: "https://paras.id/token/x.paras.near::414997",
    },
    {
      name: "MARA",
      img: mara,
      price: "RESALE ONLY",

      artwork: MARA,
      description:
        "Like everyone, I was shocked by this war in Ukraine and all the images of bombardments, assaults, soldiers etc. But what struck me the most were the children in this war. For me, war and children should not be placed in the same sentence. So I simply wanted to show a child and a man walking hand in hand with whatever belongings they could take. This scene represents the present but I wanted to project into the post-war period by giving a touch of hope, optimism and carelessness by filling the child's bag with teddy bears.",
      revealed: true,
      tags: [
        `Mara is a French collage artist who works in different galleries as well as in urban environments. Mara is a leading NFT artist within the NEAR community, with over 72,000 NEAR in trade volume to date.`,
      ],
      link: "https://paras.id/token/x.paras.near::415052",
    },
    {
      name: "EV3RETH",
      img: evereth,
      price: "RESALE ONLY",

      description: `As a machine learning artist I typically generate art from algorithms I’ve trained, find the images that speak to me and then giving them meaning. For this project I wanted to stretch myself and determine a meaning first, then create an image that represented that meaning best.
        <br/><br/>I thought about what it might feel like to suddenly find yourself in a war zone and forced to leave your home, possibly to never come back. What came to my mind were feelings of chaos, powerlessness, and isolation - being cut away from normal life..`,
      revealed: true,
      artwork: EVERETH,
      tags: [
        `EV3RETH is a very talented Machine Learning Artist & Composer that is emerging in the NEAR community. As a machine learning artist, EV3RETH generates art from trained algorithms. `,
      ],
      link: "https://paras.id/token/x.paras.near::415056",
    },
  ];
  const ctx = useContext(AppContext);
  const { toggleModal, setSelectedArtist } = ctx;
  const toggle = (txt, artist) => {
    setSelectedArtist(artist);
    toggleModal(txt);
  };
  return (
    <div id="collection" className={styles.wrapper}>
      <h1>{strings.artistSeriesHeader}</h1>
      <div className={styles.columnsWrapper}>
        {artists.map((artist, i) => (
          <div className={`${styles.column} ${i == 0 ? styles.auction : ""}`}>
            <ArtistAvatar image={artist.img} name={artist.name} />
            <Artwork
              img={artist.artwork}
              description={artist.description}
              price={artist.price}
              revealed={artist.revealed}
              name={artist.name}
              tags={artist.tags}
              link={artist.link}
              readMore={(txt) => {
                toggle(txt, artist);
              }}
            />
            {i == 0 && <b className={styles.auctionTXT}>SOLD OUT</b>}
          </div>
        ))}
      </div>
    </div>
  );
}
